import { IconZoomOutline } from '@iwoca/icons';
import { Input } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';

import styles from './BankSelectionModal.module.css';
import { TOnlineBank } from '../OpenBanking.types';

const BankGrid = ({
  banks,
  onSearch,
  searchTerm,
  onBankSelect,
}: {
  banks: TOnlineBank[];
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  searchTerm: string;
  onBankSelect: (bank: TOnlineBank) => void;
}) => {
  const { t } = useLingui();

  return (
    <>
      <Input
        iconLeft={<IconZoomOutline />}
        className={styles.searchBar}
        placeholder={t`Search for your bank...`}
        onChange={onSearch}
        value={searchTerm}
      />
      <div
        className={clsx(styles.banksGridContainer, {
          [styles.bankButtonError]: banks.length < 1,
        })}
      >
        {banks?.map((bank) => {
          return (
            <button
              key={bank.bank_id}
              className={styles.bankButton}
              onClick={() => onBankSelect(bank)}
            >
              <figure className={styles.bankButtonFigure}>
                <img
                  src={bank.logo_url}
                  alt={bank.bank_name}
                  className={clsx('fs-mask dd-privacy-mask', styles.bankLogo)}
                />
                <figcaption className={styles.bankName}>
                  {bank.bank_name}
                </figcaption>
              </figure>
            </button>
          );
        })}
        {banks.length < 1 && (
          <p className={styles.bankListError}>
            <Trans>
              Unfortunately the bank you have chosen is not supported.
            </Trans>
          </p>
        )}
      </div>
    </>
  );
};

export default BankGrid;
